import React from 'react';
import './Features.css';
import { Link } from 'react-router-dom';

// Import features data from constants
import { features } from '../../../constants';

const Features = () => {
  return (
    <section className='features'>
      
      {/* Container for feature items */}
      <div className="box-container">

        {/* Map through the features array and render each feature */}
        {features.map((feature) => (
          <Link key={feature.id} to={feature.link} className='feature-link'>
            <div className="feature-item">
              <div className='icon'>{feature.icon}</div> {/* Feature icon */}
              <h3>{feature.title}</h3> {/* Feature title */}
              <p>{feature.description}</p> {/* Feature description */}
            </div>
          </Link>
        ))}

      </div>

    </section>
  );
}

export default Features;